import i18next from '../services/i18n';

const getStatusTranslation = status => {
  if (!status) return '';

  if (status.type === 'high') {
    return i18next.t('components.gauge.status_options.high', {
      threshold_high: status.threshold_high,
      threshold_highest: status.threshold_highest,
    });
  }

  if (status.type === 'highest') {
    return i18next.t('components.gauge.status_options.highest', {
      threshold_highest: status.threshold_highest,
    });
  }

  if (status.type === 'low') {
    return i18next.t('components.gauge.status_options.low', {
      threshold_low: status.threshold_low,
      threshold_lowest: status.threshold_lowest,
    });
  }

  if (status.type === 'lowest') {
    return i18next.t('components.gauge.status_options.lowest', {
      threshold_lowest: status.threshold_lowest,
    });
  }

  if (status.type === 'normal') {
    return i18next.t('components.gauge.status_options.normal', {
      threshold_low: status.threshold_low,
      threshold_high: status.threshold_high,
    });
  }

  return '';
};

export default getStatusTranslation;
